Ember.TEMPLATES["controls/replace_with_pattern"] = Ember.Handlebars.template(function anonymous(Handlebars,depth0,helpers,partials,data
) {
this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Ember.Handlebars.helpers); data = data || {};
  var buffer = '', stack1, hashTypes, hashContexts, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression;


  hashTypes = {};
  hashContexts = {};
  options = {hash:{},contexts:[depth0],types:["ID"],hashContexts:hashContexts,hashTypes:hashTypes,data:data};
  data.buffer.push(escapeExpression(((stack1 = helpers['t'] || depth0['t']),stack1 ? stack1.call(depth0, "instructions.browse_patterns", options) : helperMissing.call(depth0, "t", "instructions.browse_patterns", options))));
  data.buffer.push("\n");
  return buffer;
  
});